import { render, staticRenderFns } from "./barginDetail.vue?vue&type=template&id=a78f44f8&scoped=true"
import script from "./barginDetail.vue?vue&type=script&lang=js"
export * from "./barginDetail.vue?vue&type=script&lang=js"
import style0 from "./barginDetail.vue?vue&type=style&index=0&id=a78f44f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78f44f8",
  null
  
)

export default component.exports